export default {
    normalize(value) {
        if (value.year === null && value.month === null) {
            value.year = new Date().getFullYear();
            value.month = new Date().getMonth();
        }
    }
};